import { mobileMediaCSS } from '@1inch-community/core/lit-utils';
import { css } from 'lit';
export const fusionSwapInfoSlippageStyle = css `
  .slippage-title {
    display: flex;
    padding: 8px;
    gap: 8px;
    color: var(--color-content-content-primary);
    align-items: center;
    margin-bottom: 8px;
    cursor: pointer;
    font-size: 16px;
  }

  .back-icon {
    transform: rotate(90deg);
  }

  ${mobileMediaCSS(css `
    .slippage-title {
      font-size: 13px;
    }
  `)}
`;
//# sourceMappingURL=fusion-swap-info-slippage.style.js.map